<ng-container *ngIf="(viewModel$ | async) as vm">
  <div class="container is-flex is-space-between is-cursor-pointer"
    (click)="openWeathermap()" ga-event="WeathermapImage">
    <div class="is-flex is-column">
      <app-text class="logo text-32 is-family-medium" text="Netatmo"></app-text>
      <app-text class="is-family-medium text-primary" text="Weathermap"></app-text>
    </div>

    <ng-container *ngIf="vm.stations.length >= 1">
      <ng-container *ngIf="vm.stations.length > 1; else copyInvitation">
        <lay-button class="share-button">
          <button type="submit" (click)="openModal($event)"
            class="is-primary-button is-flex is-justify-center">
            <app-icon class="has-spacing-right-xs text-24" name="share"></app-icon>
            <app-text [text]="'common-app.__SHARE' | LANG"></app-text>
          </button>
        </lay-button>
      </ng-container>
      <ng-template #copyInvitation>
        <lay-button class="share-button" ga-event="WeathermapShare">
          <button [share]="generateInvitation(vm.stations[0], vm.config)" (hasShared)="hasCopied($event)"
            (click)="copyLink($event)" [ngClass]="{
                      'has-shared': vm.hasCopied,
                      'is-loading': vm.hasCopied === null
                  }" type="submit" class="is-primary-button is-flex is-justify-center">
            <app-icon class="has-spacing-right-xs text-24" name="share"></app-icon>
            <app-text [text]=" vm.hasCopied ? ('common-settings.__LINK_COPIED' | LANG) : ('common-app.__SHARE' | LANG)">
            </app-text>
          </button>
        </lay-button>
      </ng-template>
    </ng-container>

  </div>

  <app-modal [display]="stationModalDisplay$ | async">
    <app-modal-header>
      <app-text class="text-20 is-family-medium" [text]="'legrand-app.__SHARE_WEATHERSTATION_WEATHERMAP' | AsyncLang | async"></app-text>
      <app-icon class="is-cursor-pointer" (click)="closeModal(vm.stations)" name="close"></app-icon>
    </app-modal-header>

    <app-modal-body class="is-flex is-flex-direction-column is-space-between">

      <app-text class="text-grey-70 text-16 is-family-medium is-flex is-justify-center description"
        [text]="'legrand-app.__SELECT_WEATHERSTATION_WEATHERMAP'| AsyncLang | async"></app-text>

      <div class="select-station has-spacing-top-xxl">
        <app-text class="text-16 is-family-regular has-spacing-bottom-xs"
          [text]="'station-app.__STATION_DEFAULT_NAME' | LANG"></app-text>
        <app-dropdown class="is-fullwidth" [formControl]="weatherControl">
          <app-dropdown-value></app-dropdown-value>

          <ng-container *ngFor="let station of vm.stations">
            <app-dropdown-item [value]="station.value" [label]="station.value.name"></app-dropdown-item>
          </ng-container>
        </app-dropdown>
      </div>

      <lay-button class="is-flex-button has-spacing-top-xxl">
        <button [share]="generateInvitation(weatherControl.value, vm.config)" (hasShared)="hasCopied($event)"
          (click)="copyLink($event)" [ngClass]="{
                    'has-shared': vm.hasCopied,
                    'is-loading': vm.hasCopied === null
                }" type="submit" class="is-primary-button is-flex is-justify-center">
          <app-text [text]=" vm.hasCopied ? ('common-settings.__LINK_COPIED' | LANG) : ('common-app.__SHARE' | LANG)">
          </app-text>
        </button>
      </lay-button>


    </app-modal-body>

  </app-modal>
</ng-container>
